<template>
  <div>
    <hpo-filter
      :filter-columns="headers"
      :current-item="filterConditions"
      @enter="filter_data"
    ></hpo-filter>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :server-items-length="total_rows"
      :options.sync="pagination"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 50, 100]
      }"
      class="elevation-1"
    >
      <template v-slot:item.created_at="{ item }">
        {{ item.created_at | display_date }}
      </template>

      <template v-slot:item.content="{ item }">
        <div style="max-width: 400px; white-space: pre-wrap;">
            <span v-html="item.content"></span>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Filtering from "@/components/Filtering";

export default {
  components: {
    "hpo-filter": Filtering
  },
  data() {
    return {
      viewName: "system_log",
      filterConditions: [],
      pagination: {
        page: 1,
        itemsPerPage: 20,
        sortBy: ["id"],
        sortDesc: [true]
      },
      headers: [
        {
          text: "ID",
          value: "id",
          width: 100,
          filterable: true,
          sortable: true
        },
        {
          text: "Người dùng",
          value: "user_name",
          width: 150,
          filterable: true,
          sortable: true
        },
        {
          text: "Chức năng",
          value: "function_name",
          width: 200,
          filterable: true,
          sortable: true
        },
        {
          text: "Thời gian",
          value: "created_at",
          width: 180,
          filterable: true,
          sortable: true
        },
        {
          text: "Nội dung",
          value: "content",
          filterable: true,
          sortable: false
        }
      ]
    };
  },
  computed: {
    ...mapState({
      items: state => state.systemLog.all.data,
      total_rows: state => state.systemLog.all.total,
      loading: state => state.systemLog.loading
    })
  },
  watch: {
    pagination: {
      handler() {
        this.filter_data();
      },
      deep: true
    }
  },
  methods: {
    filter_data() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions
      };
      this.$store.dispatch("systemLog/getList", param);
    }
  },
  mounted() {
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>
